import { withErrorBoundary } from 'components/ErrorBoundary';
import CustomLink from 'components/Globals/Base/Link';
import getEarningReportPageTestId from 'constants/testsIds/earningsReportPage';
import { useRouter } from 'next/router';
import type { EventData } from 'services/Gtm/entities';
import { SocialLinkContainer, SocialLinksContainer } from './SocialLinksStyles';

interface SocialLinksProps {
  title: string;
  className?: string;
  usedInHeader?: boolean;
  trackingData?: EventData;
  isListPage?: boolean;
  variant?: string;
}

interface socialLinks {
  platform: string;
  classNameAppend?: string;
  tracking: string;
  url: string;
  hideInHeader?: boolean;
}
const SocialLinks = ({
  title,
  className,
  usedInHeader = false,
  trackingData,
  isListPage,
  variant,
}: SocialLinksProps) => {
  const router = useRouter();
  const baseUrl = `https://fortune.com${router.asPath}`;
  const queryParams = isListPage
    ? `?utm_content=${variant}&utm_source=ranking&utm_medium=`
    : `?utm_content=${variant}&utm_medium=`;

  const encodedTitle = encodeURIComponent(title);

  const socialLinks: socialLinks[] = [
    {
      platform: 'facebook',
      classNameAppend: '-square',
      tracking: getEarningReportPageTestId('FACEBOOK_ICON'),
      url: usedInHeader
        ? 'https://www.facebook.com/FortuneMagazine/'
        : `https://www.facebook.com/sharer.php/?u=${encodeURIComponent(baseUrl + queryParams + 'facebook&utm_campaign=social_share')}`,
    },
    {
      platform: 'twitter',
      classNameAppend: '',
      tracking: getEarningReportPageTestId('X_ICON'),
      url: usedInHeader
        ? 'https://twitter.com/FortuneMagazine/'
        : `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodeURIComponent(baseUrl + queryParams + 'x&utm_campaign=social_share')}`,
    },
    {
      platform: 'linkedin',
      classNameAppend: '',
      tracking: getEarningReportPageTestId('LINKEDIN_ICON'),
      url: usedInHeader
        ? 'https://www.linkedin.com/company/fortune-magazine/'
        : `https://www.linkedin.com/shareArticle/?url=${encodeURIComponent(baseUrl + queryParams + 'linkedin&utm_campaign=social_share')}`,
    },
    {
      platform: 'email',
      classNameAppend: '',
      tracking: getEarningReportPageTestId('EMAIL_ICON'),
      url: `mailto:?subject=${title}&body=${encodeURIComponent(baseUrl + queryParams + 'email&utm_campaign=social_share')}`,
      hideInHeader: true,
    },
  ];

  return (
    <SocialLinksContainer className={className}>
      {socialLinks.map(({ platform, url, hideInHeader, classNameAppend, tracking }) =>
        !hideInHeader || !usedInHeader ? (
          <SocialLinkContainer key={platform}>
            <CustomLink
              data-cy={tracking}
              className={`social ${platform}${classNameAppend}`}
              ariaLabel={`go to ${platform}`}
              target='_blank'
              rel='noopener noreferrer'
              href={url}
              trackingData={
                trackingData && {
                  ...trackingData,
                  eventAction: `${trackingData.eventAction} ${platform.charAt(0).toUpperCase() + platform.slice(1)}`,
                  eventLabel: url,
                }
              }
            />
          </SocialLinkContainer>
        ) : null,
      )}
    </SocialLinksContainer>
  );
};

export default withErrorBoundary(SocialLinks);
